"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "main-container" };
const _hoisted_2 = { class: "reservations-list" };
const _hoisted_3 = { class: "list-top" };
const _hoisted_4 = { class: "left" };
const _hoisted_5 = { class: "right" };
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "text" }, "Időszak", -1);
const _hoisted_7 = { class: "period-selects" };
const _hoisted_8 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", null, "2023.01.12", -1);
const _hoisted_9 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", null, "2023.01.13", -1);
const _hoisted_10 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", null, "2023.01.14", -1);
const _hoisted_11 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", null, "2023.01.15", -1);
const _hoisted_12 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", null, "2023.03.16", -1);
const _hoisted_13 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", null, "2023.01.12", -1);
const _hoisted_14 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", null, "2023.01.13", -1);
const _hoisted_15 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", null, "2023.01.14", -1);
const _hoisted_16 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", null, "2023.01.15", -1);
const _hoisted_17 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", null, "2023.03.16", -1);
const _hoisted_18 = { class: "element" };
const _hoisted_19 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", null, "Státusz", -1);
const _hoisted_20 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", null, "nyitott", -1);
const _hoisted_21 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", null, "jóváhagyott", -1);
const _hoisted_22 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", null, "törölt", -1);
const _hoisted_23 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", null, "lezárt", -1);
const _hoisted_24 = { class: "element" };
const _hoisted_25 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", null, "Foglalás eredete", -1);
const _hoisted_26 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", null, "Online foglalás", -1);
const _hoisted_27 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", null, "Szervizben felvett", -1);
const _hoisted_28 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", null, "BHP", -1);
const _hoisted_29 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", null, "Marso", -1);
const _hoisted_30 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", null, "Marso Flotta", -1);
const _hoisted_31 = { class: "list-table" };
const CalendarFooter_vue_1 = __importDefault(require("../footer/CalendarFooter.vue"));
const Form_1 = require("../../../../components/Form");
const CustomSelect_vue_1 = __importDefault(require("../../../../components/backend/CustomSelect.vue"));
const TableHeader_vue_1 = __importDefault(require("./TableHeader.vue"));
const TableRow_vue_1 = __importDefault(require("./TableRow.vue"));
const ReservationModal_vue_1 = __importDefault(require("../modal/ReservationModal.vue"));
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ReservationsList',
    setup(__props) {
        let isModalOpen = (0, vue_3.ref)(false);
        const openModal = () => {
            isModalOpen.value = true;
        };
        const closeModal = () => {
            isModalOpen.value = false;
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (0, vue_2.createElementVNode)("div", _hoisted_3, [
                            (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                    "custom-class": "w-72 bold",
                                    "is-search": true,
                                    placeholder: "Keresés...",
                                    name: "search"
                                })
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                _hoisted_6,
                                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                    (0, vue_2.createVNode)(CustomSelect_vue_1.default, { "custom-class": "bold" }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            _hoisted_8,
                                            _hoisted_9,
                                            _hoisted_10,
                                            _hoisted_11,
                                            _hoisted_12
                                        ]),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(CustomSelect_vue_1.default, { "custom-class": "bold" }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            _hoisted_13,
                                            _hoisted_14,
                                            _hoisted_15,
                                            _hoisted_16,
                                            _hoisted_17
                                        ]),
                                        _: 1
                                    })
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_18, [
                                    (0, vue_2.createVNode)(CustomSelect_vue_1.default, { "custom-class": "bold" }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            _hoisted_19,
                                            _hoisted_20,
                                            _hoisted_21,
                                            _hoisted_22,
                                            _hoisted_23
                                        ]),
                                        _: 1
                                    })
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_24, [
                                    (0, vue_2.createVNode)(CustomSelect_vue_1.default, { "custom-class": "bold" }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            _hoisted_25,
                                            _hoisted_26,
                                            _hoisted_27,
                                            _hoisted_28,
                                            _hoisted_29,
                                            _hoisted_30
                                        ]),
                                        _: 1
                                    })
                                ])
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("table", _hoisted_31, [
                            (0, vue_2.createVNode)(TableHeader_vue_1.default),
                            (0, vue_2.createElementVNode)("tbody", null, [
                                ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(10, (n) => {
                                    return (0, vue_2.createVNode)(TableRow_vue_1.default, {
                                        key: n,
                                        onClick: _cache[0] || (_cache[0] = ($event) => (openModal()))
                                    });
                                }), 64))
                            ])
                        ])
                    ])
                ]),
                (0, vue_2.createVNode)(ReservationModal_vue_1.default, {
                    "is-open": (0, vue_2.unref)(isModalOpen),
                    onClose: closeModal
                }, null, 8, ["is-open"]),
                (0, vue_2.createVNode)(CalendarFooter_vue_1.default)
            ], 64));
        };
    }
});
